export const UserRegistrationFormConstants = {
  StoreSliceName: "UserRegistrationForm",
};
